import { Link } from "react-router-dom";

const features = [
  { icon: "ri-book-open-line", title: "剧情导读", desc: "完整梳理故事脉络与人物关系" },
  { icon: "ri-filter-3-line", title: "多维筛选", desc: "地区、年份、类型自由组合" },
  { icon: "ri-compass-3-line", title: "智能推荐", desc: "依据题材标签为你挑选相似佳作" },
];

export default function SiteIntro() {
  return (
    <section className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-8 md:py-16">
      <div className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-10">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
              <i className="ri-information-line" />
              关于本站
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              读懂日韩伦理剧情片的人性与情感
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              日韩伦理片是一个专注于日韩伦理剧情影视作品的资料平台。我们整理影片的基本信息、主创阵容与剧情简介，
              帮助你在观影前快速了解每一部作品的故事走向与情感内核。本站仅提供信息介绍，不提供任何在线播放服务。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/category"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                开始浏览片库
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-200"
              >
                了解我们的定位
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
            {features.map((f) => (
              <div
                key={f.title}
                className="rounded-lg border border-background-200 bg-background-50 p-4"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className={`${f.icon} text-lg`} />
                </span>
                <h3 className="mt-3 font-heading text-sm font-semibold text-foreground-950">
                  {f.title}
                </h3>
                <p className="mt-1 text-xs leading-relaxed text-foreground-600">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}